export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const LOAD_LOCATION = 'LOAD_LOCATION'
